import { useUser, useClerk } from '@clerk/clerk-react';
import { LogOut, User } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from '../components/ui/dropdown-menu';

export function UserMenu() {
  const { user } = useUser();
  const { signOut } = useClerk();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="flex items-center gap-2 rounded-full p-1 hover:bg-surface-raised">
        <div className="flex h-8 w-8 items-center justify-center rounded-full bg-red-accent text-sm font-medium text-text-primary">
          {user?.fullName?.[0]?.toUpperCase() ?? <User className="h-4 w-4" />}
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <div className="px-2 py-1.5">
          <p className="text-sm font-medium text-text-primary">{user?.fullName}</p>
          <p className="text-xs text-text-secondary">{user?.primaryEmailAddress?.emailAddress}</p>
        </div>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onClick={() => signOut({ redirectUrl: window.location.origin })}
        >
          <LogOut className="mr-2 h-4 w-4" />
          Sign out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
